import { AbstractControl } from '@angular/forms';

export function TldValidator(control: AbstractControl): { [key: string]: any } | null {
  return !/.*@.+\..+/.test(control.value) ? { tld_missing: { value: control.value } } : null;
}
